import React, { useContext, useEffect, useState, useRef } from 'react'
import ReactPlayer from 'react-player'
import DashboardLayout from '../Dashboard/DashboardLayout'
import '../Dashboard/Dashboard.css'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SavedCard from './SavedCard'
import { Button, Link } from '@material-ui/core'
import QRCode from 'react-qr-code'
import AuthContext from '@/product/context/auth/authContext'
import CustomDialog from '@/custom/components/organisms/CustomDialog'
import { LOGO, SITE_NAME } from '@/utils/index'
import PasswordSecurity from './PasswordSecurity'
import Myaccount from './Profile/Myaccount'
import Notifications from './Profile/Notifications'
import MyInterest from './SavedSearch/MyInterest'
import SavedSearchBody from './SavedSearch/SavedSearchBody'
import { handleRedirectInternal } from '@/product/common/components'
import { useHistory } from 'react-router-dom'
import CustomCommonContext from '@/custom/context/common/commonContext'
import { AccountCircle } from '@material-ui/icons'

export default function MyAccountMain(props) {
    const authContext = useContext(AuthContext)
    const customCommonContext = useContext(CustomCommonContext)
    const { user } = authContext
    const { allConfigurationVariables } = customCommonContext
    const [qrCodePopup, setQrCodePopup] = useState(false)
    const [activeTab, setActiveTab] = useState('main')
    const [videoPopup, setVideoPopup] = useState(false)
    const [videoLink, setVideoLink] = useState('')
    const changeQrPopupStatus = () => {
        setQrCodePopup(!qrCodePopup)
    }
    const history = useHistory()
    useEffect(() => {
        const savedTab = localStorage.getItem('activeTab')
        if (savedTab) {
            setActiveTab(savedTab)
        }
    }, [])

    useEffect(() => {
        localStorage.setItem('activeTab', activeTab)
    }, [activeTab])

    const getlinkTutorial = useRef()

    const handleScrollFuntion = () => {
        getlinkTutorial.current?.scrollIntoView({ behavior: 'smooth' })
    }

    if (window.location.hash == '#tutorialSec') {
        handleScrollFuntion()
    }

    const changeVideoPopupStatus = (link = '') => {
        setVideoPopup(!videoPopup)
        setVideoLink(link)
    }

    const handleVideoClick = (link = '') => {
        setVideoPopup(true)
        setVideoLink(link)
    }

    return (
        <>
            <DashboardLayout title="Account">
                {activeTab === 'main' ? (
                    <div className="accMain">
                        <div className="accQr">
                            <div
                                className="d-flex align-items-center justify-content-center qrHead"
                                style={{ gap: '50px' }}
                            >
                                <QRCode
                                    onClick={() => setQrCodePopup(true)}
                                    value={user?.id?.toString() || ''}
                                />
                                <div className="memberId" onClick={() => setQrCodePopup(true)}>
                                    Member ID <img src="./assets/images/pan_zoom.svg" />
                                </div>
                                {/* <div className="qrNotif">
                                    <span className="material-icons-outlined">notifications</span>
                                </div> */}
                            </div>
                        </div>
                        <div className="row accountPaths py-5">
                            <div className="col-12 col-md-6">
                                <img src="/assets/images/creditCard.svg" />
                                <PrimaryButton
                                    label="Manage Credit Cards"
                                    onClick={() =>
                                        handleRedirectInternal(history, 'payments/saved_cards')
                                    }
                                />
                            </div>
                            <div className="col-12 col-md-6">
                                <img src="/assets/images/passSecIcon.svg" />
                                <PrimaryButton
                                    label="Password & Security"
                                    onClick={() =>
                                        handleRedirectInternal(history, 'my-account/password')
                                    }
                                />
                            </div>
                            <div className="col-12 col-md-6">
                                <img src="/assets/images/homeIcon.svg" />
                                <PrimaryButton
                                    label="Personal Information"
                                    onClick={() =>
                                        handleRedirectInternal(history, 'my-account/personal')
                                    }
                                />
                            </div>
                            <div className="col-12 col-md-6">
                                <img src="/assets/images/envelopeIcon.svg" />
                                <PrimaryButton
                                    label="Email & SMS Preferences"
                                    onClick={() =>
                                        handleRedirectInternal(history, 'my-account/notifications')
                                    }
                                />
                            </div>
                            <div className="col-12 col-md-6">
                                <img src="./assets/images/bookmarkIcon.svg" />
                                <PrimaryButton
                                    label="Saved Searches"
                                    onClick={() =>
                                        handleRedirectInternal(history, 'my-account/saved_search')
                                    }
                                />
                            </div>
                            <div className="col-12 col-md-6">
                                <img src="./assets/images/officeIcon.svg" />
                                <PrimaryButton
                                    label="Interests"
                                    onClick={() =>
                                        handleRedirectInternal(history, 'my-account/my-interests')
                                    }
                                />
                            </div>
                            {/* <div className="col-12 col-md-6">
                                <img src="./assets/images/pendingIcon.svg" />
                                <PrimaryButton
                                    label="Recently Viewed"
                                    onClick={() => setActiveTab('viewed')}
                                />
                            </div> */}
                            <div className="col-12 col-md-6">
                                <img src="./assets/images/questionIcon.svg" />
                                <PrimaryButton
                                    label="Frequently Asked Questions"
                                    onClick={() => handleRedirectInternal(history, 'contact-us')}
                                />
                            </div>
                            <div className="col-12 col-md-6">
                                <img src="./assets/images/editIcon.svg" />
                                <PrimaryButton
                                    label="Terms & Conditions"
                                    onClick={() =>
                                        handleRedirectInternal(history, 'terms-and-conditions')
                                    }
                                />
                            </div>
                            <div className="col-12 col-md-6">
                                <img src="./assets/images/packageIcon.svg" />
                                <PrimaryButton
                                    label="Returns"
                                    onClick={() =>
                                        handleRedirectInternal(
                                            history,
                                            'my-orders?status=2&status=3',
                                        )
                                    }
                                />
                            </div>
                            {/* {allConfigurationVariables?.archived_account_redirect_url ? (
                                <div className="col-12 col-md-6 lastingDate">
                                    <AccountCircle style={{ color: '#6B6E79', margin: '0' }} />
                                    <PrimaryButton
                                        label="Archived Account"
                                        onClick={() =>
                                            window.open(
                                                allConfigurationVariables.archived_account_redirect_url,
                                                '_blank',
                                            )
                                        }
                                    />
                                    {allConfigurationVariables?.archived_account_button_text ? (
                                        <div
                                            style={{
                                                color: '#1c1717ff',
                                                fontSize: '12px',
                                                marginTop: '4px',
                                            }}
                                            className="lastDate"
                                        >
                                            {
                                                allConfigurationVariables?.archived_account_button_text
                                            }
                                        </div>
                                    ) : null}
                                </div>
                            ) : null} */}
                        </div>
                        <div
                            className="tutorials-wrapper mt-4 mb-4"
                            id="tutorialSec"
                            ref={getlinkTutorial}
                        >
                            <h1 className="title mb-1">TUTORIALS</h1>
                            <h5 className="dashSubtitle">Explore our 1-3 minute How-To videos</h5>
                            <div className="tut-vid-btns">
                                <Button
                                    className="tutorials-button"
                                    onClick={() =>
                                        handleVideoClick(
                                            allConfigurationVariables?.tutorials_whats_new ||
                                                'https://www.youtube.com/watch?v=OIdExntO-jw',
                                        )
                                    }
                                >
                                    What&#39;s New
                                </Button>
                                <Button
                                    className="tutorials-button"
                                    onClick={() =>
                                        handleVideoClick(
                                            allConfigurationVariables?.tutorials_purchasing_items ||
                                                'https://www.youtube.com/watch?v=OIdExntO-jw',
                                        )
                                    }
                                >
                                    Purchasing Items
                                </Button>
                                <Button
                                    className="tutorials-button"
                                    onClick={() =>
                                        handleVideoClick(
                                            allConfigurationVariables?.tutorials_storage_policies ||
                                                'https://www.youtube.com/watch?v=OIdExntO-jw',
                                        )
                                    }
                                >
                                    Storage Policies
                                </Button>
                                <Button
                                    className="tutorials-button"
                                    onClick={() =>
                                        handleVideoClick(
                                            allConfigurationVariables?.tutorials_pickup_instruction ||
                                                'https://www.youtube.com/watch?v=OIdExntO-jw',
                                        )
                                    }
                                >
                                    Pickup Instructions
                                </Button>
                                <Button
                                    className="tutorials-button"
                                    onClick={() =>
                                        handleVideoClick(
                                            allConfigurationVariables?.tutorials_how_to_pay ||
                                                'https://www.youtube.com/watch?v=OIdExntO-jw',
                                        )
                                    }
                                >
                                    How to Pay
                                </Button>
                                <Button
                                    className="tutorials-button"
                                    onClick={() =>
                                        handleVideoClick(
                                            allConfigurationVariables?.tutorials_how_to_make_a_return ||
                                                'https://www.youtube.com/watch?v=OIdExntO-jw',
                                        )
                                    }
                                >
                                    How to Make a Return
                                </Button>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div>
                        <div className="maTitle d-flex justify-content-between align-items-center w-100">
                            <Button
                                onClick={() => {
                                    setActiveTab('main')
                                }}
                                className="moveBack"
                            >
                                <span className="material-icons">keyboard_arrow_left</span>
                                {'Back to Account'}
                            </Button>
                        </div>
                        {activeTab === 'manage' && <SavedCard />}
                        {activeTab === 'password' && (
                            <PasswordSecurity setActiveTab={setActiveTab} />
                        )}
                        {activeTab === 'personal' && <Myaccount />}
                        {activeTab === 'preference' && <Notifications />}
                        {activeTab === 'interests' && <MyInterest />}
                        {activeTab === 'saved' && <SavedSearchBody />}
                    </div>
                )}
                <CustomDialog
                    open={qrCodePopup}
                    disableBackdropClick
                    function={changeQrPopupStatus}
                    className="qrAccount"
                >
                    <div className="d-flex align-items-center accProf mb-4 justify-content-around">
                        <div className="userAvatarProfile">
                            {/* <span className="userInitials large">
                                {user?.first_name?.charAt(0)}
                                {user?.last_name?.charAt(0)}{' '}
                            </span> */}
                            {user?.avatar ? (
                                <>
                                    <img
                                        src={`${global.site_url}/uploads/avatar/${user?.avatar}`}
                                        alt="Avatar"
                                        className="userAvatar large"
                                    />
                                </>
                            ) : (
                                <>
                                    <span className="material-icons">person</span>
                                    {/* <span className="userInitials large">
                                        {user?.first_name?.charAt(0)}
                                        {user?.last_name?.charAt(0)}
                                    </span> */}
                                </>
                            )}
                        </div>
                        <div>
                            <h1>
                                {user?.first_name} {user?.last_name}
                            </h1>
                            <h4>{user?.username}</h4>
                        </div>
                    </div>
                    <QRCode value={user?.id?.toString() || ''} />
                    <Link to="/" className="header-logo" id="header-logo">
                        <img src={LOGO} alt={SITE_NAME} width="157" height="47" />
                    </Link>
                </CustomDialog>
                <CustomDialog
                    open={videoPopup}
                    function={changeVideoPopupStatus}
                    className="videoPopup"
                >
                    <div style={{ position: 'relative', paddingTop: '56.25%' }}>
                        <ReactPlayer
                            url={videoLink}
                            width="100%"
                            height="100%"
                            playing={videoPopup}
                            controls={true}
                            muted={false}
                            playsinline
                            pip={false}
                            loop={false}
                            config={{
                                youtube: {
                                    playerVars: {
                                        autoplay: 1,
                                        hd: 1,
                                        showinfo: 0,
                                        rel: 0,
                                        modestbranding: 1,
                                        iv_load_policy: 3,
                                        cc_load_policy: 0,
                                        fs: 1,
                                        disablekb: 0,
                                        autohide: 1,
                                        controls: 1,
                                        quality: 'highres',
                                    },
                                },
                            }}
                            style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                            }}
                        />
                    </div>
                </CustomDialog>
            </DashboardLayout>
        </>
    )
}
